import React, { useEffect, useState, useLayoutEffect, } from 'react'
import '../styles/program.scss'
import _ from 'lodash'

import moment from 'moment'
import ShowtimeProgram from './ShowtimeProgram';




import { useLocation } from "react-router-dom";
import LOCALE from '../../datepicker/DatePickerLocale'
import ShowtimeListItems from './ShowtimeListItems';





export default function ShowtimeList({ movieAtCinemas, lastShowtimeDay, already_selected_date }) {
   
    const [currentStartDate, setCurrentStartDate] = useState(already_selected_date ? moment(already_selected_date,'DD-MM-YYYY') : moment())
    const [take, setTake] = useState(7);

    const [nextArrowClk, setNextArrowClk] = useState(false);
    const [backArrowClk, setBackArrowClk] = useState(false)
    const [nextShowArrowClk, setNextShowArrowClk] = useState(false)
    const [lastShowArrowClk, setLastShowArrowClk] = useState(false)
    const [nextValidWeekClk, setNextValidWeekClk] = useState(false)

    const showtimeTypes = [];
    let startDate = currentStartDate;

    function nextValidWeek(forrigeDiffer) {
        setNextValidWeekClk((current) => !current)
       

        var ugedag = moment().day();
        var ugedag_film = currentStartDate.clone().add((forrigeDiffer), 'days').day();
        //  console.log(ugedag, ugedag_film)
        var hop = forrigeDiffer + (ugedag - ugedag_film)
        // console.log(hop, 'hop')
        if (take < 7) {
            setCurrentStartDate(currentStartDate.add(forrigeDiffer, 'days'))
        }
        else {
            setCurrentStartDate(currentStartDate.add(ugedag_film > ugedag || ugedag_film === ugedag ? hop : hop - take, 'days'))
        }

        if (currentStartDate < moment()) { setCurrentStartDate(moment()) }
      


    }
   

    function nextWeek() {
        setNextArrowClk((current) => !current)
     //   console.log('next week')
       // console.log(currentStartDate.add(take, 'days'))
      
        setCurrentStartDate(currentStartDate.add(take, 'days'))
         if (currentStartDate < moment()) { setCurrentStartDate(moment()) }

    }
    //useEffect(() => {
    //    console.log(nextArrowClk, 'DATE CLICK')
    //    setCurrentStartDate(currentStartDate.add(take, 'days'))
    //}, [nextArrowClk])

    function previousWeek() {
        setBackArrowClk((current) => !current)
     //   console.log('pre week')
        setCurrentStartDate(currentStartDate.subtract(take, 'days'))
        if (currentStartDate < moment()) { setCurrentStartDate(moment()) }

    }


    useEffect(() => {
        if (currentStartDate < moment()) { setCurrentStartDate(moment()) }

    }, [])

    function firstWeek(differ) {
        //console.log(take, 'take')
        setNextShowArrowClk((current) => !current)
       // console.log(differ, 'differrrrr')
        if (take < 7) {
            // console.log('yes')
            setCurrentStartDate(currentStartDate.add(differ, 'days'))
        }
        else {
            var ugedag = moment().day();
            var ugedag_film = currentStartDate.clone().add((differ), 'days').day();
            //  console.log(ugedag, ugedag_film, 'ugee')

            var hop = differ + (ugedag - ugedag_film);
            // console.log(hop, 'hop')

            // if ugedag_film is SMALLER than ugedag than add (hop - take) days otherwise add hop days


            hop > take ? setCurrentStartDate(currentStartDate.add(ugedag_film < ugedag ? hop - take : hop, 'days')) :
                setCurrentStartDate(currentStartDate.add((take), 'days'))
        }

        if (currentStartDate < moment()) { setCurrentStartDate(moment()) }
        
    }

    function lastWeek(diff) {
        setLastShowArrowClk((current) => !current)
        //  console.log(diff, 'diff')

        if (take < 7) {

            setCurrentStartDate(currentStartDate.subtract(diff, 'days'))
        }
        else {
            var ugedag = moment().day();
            var ugedag_film = currentStartDate.clone().add((diff), 'days').day();
            // console.log(ugedag, ugedag_film)
            var hop = diff + (ugedag - ugedag_film)
            // console.log(hop, 'hop')
            if (diff > take) {
                setCurrentStartDate(currentStartDate.subtract(ugedag_film > ugedag ? hop + take : hop, 'days'))
            }
            else if (diff < 0) {
                setCurrentStartDate(currentStartDate.add(ugedag_film > ugedag ? hop - take : hop, 'days'))

            }
            else setCurrentStartDate(currentStartDate.subtract(take, 'days'))
        }


        if (currentStartDate < moment()) { setCurrentStartDate(moment()) }

    }

    function useWindowSize() {
        const [size, setSize] = useState([0, 0]);
        useLayoutEffect(() => {
            function updateSize() {
               // const schedule = document.querySelector('.showtimeScheduleWeek');

               // console.log(schedule.clientWidth)
                setSize([window.innerWidth, window.innerHeight]);
               
            }
            window.addEventListener('resize', updateSize);
            updateSize();
            return () => window.removeEventListener('resize', updateSize);
        }, []);
        return size;
    }
    const [width, height] = useWindowSize();

    useEffect(() => {
  //  console.log(width, 'use window size')
       
        // window.addEventListener('resize', reSize);

        width < 935 && width > 806 ? setTake(6)
            : width < 806 && width > 667 ? setTake(5)
                : width < 667 && width > 549 ? setTake(4)
                    : width < 550 && width > 450 ? setTake(3)
                        : width < 450 && width > 430 ? setTake(2)
                            : width < 430 && width > 375 ? setTake(6) : width < 375 ? setTake(5)
                        : setTake(7)

        if (take > 7) setTake(7)

        //console.log(window.innerWidth)
   })
   // console.log(document.querySelector('.orgs_container').clientWidth)
    function reSize() {
        
        const schedule = document.querySelector('.showtimeScheduleWeek');
       // console.log(schedule.clientWidth, 'schdule')
       // determineTakeFromScreenWidth()
    }



    function determineTakeFromScreenWidth() {
      
        const schedule = document.querySelector('.showtimeScheduleWeek');
      //  console.log(schedule.clientWidth, 'schdule')
      //  console.log(schedule.scrollWidth, schedule.offsetWidth, schedule.clientWidth)
        const scheduleWidth = Math.round(Math.min(schedule.scrollWidth, schedule.offsetWidth, schedule.clientWidth));
      //      console.log(scheduleWidth, 'schdl width')
        const showtimeItem = document.querySelector('.showtimes-on-date');
        const showtimeItemWidth = Math.round(Math.max(showtimeItem.scrollWidth, showtimeItem.offsetWidth, showtimeItem.clientWidth));
        // console.log(Math.floor(scheduleWidth / showtimeItemWidth))
        (scheduleWidth < 879 && window.innerWidth > 431) || window.innerWidth < 380 ? setTake(Math.floor(scheduleWidth / showtimeItemWidth)) : setTake(7)

        //if (scheduleWidth < 879 && window.innerWidth > 420 ) {
        //    setTake(Math.floor(scheduleWidth / showtimeItemWidth))
        //}
        //else if (window.innerWidth < 385) {
        //    setTake(Math.floor(scheduleWidth / showtimeItemWidth))
        //}
        //else {
        //    setTake(7)
        //}

        return Math.floor(scheduleWidth / showtimeItemWidth);
    }

   // console.log(movieAtCinemas, 'movie at cinemas')
  


    const generateShowtimeListItems = (movieAtCinemas) => {
        return _.map(movieAtCinemas, (cinema) =>
          
            <ShowtimeListItems
                firstWeek={differ => firstWeek(differ)}
                lastWeek={diff => lastWeek(diff)}   
                cinema={cinema}
                nextWeek={nextWeek}
                previousWeek={previousWeek}
                currentStartDate={currentStartDate}
                take={take}
                nextValidWeek={forrigeDiffer => nextValidWeek(forrigeDiffer)}
                lastShowtimeDay={lastShowtimeDay} />
        )
    }

    const showtimeListItems = generateShowtimeListItems(movieAtCinemas)

    return (
        <>
           {showtimeListItems}

        </>
    )
}